import GalleryCodeSnippet from "./GalleryCodeSnippet";

export default GalleryCodeSnippet;
